import 'vendor/cocoon';
import 'vendor/easy-autocomplete';
import 'tempusdominus-bootstrap-4';
import Cleave from 'cleave.js';
import OnloadHandler from 'onload_handler';
import { SubjectCategory, SubjectType } from 'enumerations.js.erb';

(function () {


  const toggleSubjectDomicile = function(){
    if ($('#subject_domicile_same_as_residence').prop('checked')) {
      $('#subject-domicile-data').hide();
    } else {
      $('#subject-domicile-data').show();
    }
  }

  const togglePersonBusiness = function(){
    if ($('#subject_subject_category').val()==SubjectCategory.PERSON) {
      $('.person-data').show();
      $('.business-data').hide();
    } else if ($('#subject_subject_type').val()==SubjectType.PRIVATE_PERSON)  {
      $('.person-data').show();
      $('.business-data').show();
    } else {
      $('.person-data').hide();
      $('.business-data').show();      
    }
  }

  const setupSubject = function(){
    $('#subject_domicile_same_as_residence').on('click', toggleSubjectDomicile);
    $('#subject_subject_category').on('change', togglePersonBusiness);
    $('#subject_subject_type').on('change', togglePersonBusiness);
  }

  const setupDelivery = function(){
    var deliveryCountyToggle = toggleCountryFields($('#delivery_country_id').closest('form'), '#delivery_country_id', 'delivery-place')
    $('#delivery_country_id').on('change', deliveryCountyToggle);
    deliveryCountyToggle();
  }

  const SubjectDocumentDropzone = function(){

      var element,
          fileField,
          formElement,
          thatField,
          dropzonePreview = `
            <div class="dz-preview dz-file-preview">
              <div class="dz-details">
                <div class="dz-filename badge badge-secondary"><span data-dz-name></span></div>
                <i data-dz-remove class="thumb-remove"><i class="fa fa-minus-circle" aria-hidden="true"></i></i>
              </div>
            </div>
          `,
          dropzoneObj,
          dropzoneOptions = {
            dictFallbackText:  null,
            dictInvalidFileType: "Il file scelto non è di un formato supportato",
            dictFileTooBig: "Il file scelto è troppo grande",
            dictResponseError: "Un problema ha impedito di completare la richiesta",
            dictCancelUpload: "Annulla caricamento",
            dictCancelUploadConfirmation: "Confermi di annullare il caricamento",
            dictRemoveFile: "Rimuovi file",
            dictMaxFilesExceeded: "Numero massimo di file raggiunto",
            autoProcessQueue: false,
            uploadMultiple: true,

            // parallelUploads:
            headers: {'X-CSRF-Token': $('meta[name=csrf-token]').attr('content')}
          };

      function cdd(){
      };

      cdd.setup = function(fieldselector) {
        if($(fieldselector).length>0){
          element = $(fieldselector);
          fileField = element.find("input[type=file]");
          formElement = element.closest('form');
          var previewsContainer = element.find('.subject-document-preview');
          var button = element.find('.subject-document-button');
          var options = $.extend({}, dropzoneOptions, {
              url: formElement.attr('action'),
              inputName: fileField.attr('name'),
              inputId: fileField.attr('id'),
              formId: formElement.attr('id'),
              maxFilesize: element.data('max-filesize'),
              maxFiles: element.data('max-files'),
              previewTemplate: dropzonePreview,
              previewsContainer: previewsContainer[0],
              clickable: button[0],
              currentObjectFiles: []
          });

          dropzoneObj = new Dropzone(element[0], options);
        }
      }

      return cdd;
  };
  window.SubjectDocumentDropzone = SubjectDocumentDropzone;

  // const setupSubjectDocumentsForm = function(){
  //   _.each($('.subject-document-dropzone'), function(el){
  //     SubjectDocumentDropzone().setup(el);
  //   });
  //
  //   $('.remove-subject-document').on('cocoon:before-remove', function(event, element) {
  //     var confirmation = confirm("Eliminare il documento?");
  //     if( confirmation === false ){
  //       event.preventDefault();
  //     } else {
  //       // allow some time for the animation to complete
  //       $(this).data('remove-timeout', 1000);
  //       element.fadeOut('slow');
  //     }
  //   });
  // }

  const setupSubjectWarehouseElement = function(insertedItem){
    var destroyField = insertedItem.find('.row-destroy');
    const removeRow = function(event){
      event.preventDefault();
      destroyField.val('1');
      insertedItem.hide();
    };
    var removeButton = insertedItem.find('.row-remove');
    removeButton.on('click', removeRow);
  }

  const setupSubjectWarehouseForm = function(){
    $(document).on('cocoon:after-insert', function(e, insertedItem, originalEvent) {
      if ($(insertedItem).hasClass('subject-warehouse-element')) {
        setupSubjectWarehouseElement(insertedItem);
      }
    });
    _.each($('.subject-warehouse-element'), function(el){
      setupSubjectWarehouseElement($(el));
    });
  }

  const setupSubjectGenericAddressElement = function(insertedItem){
    var destroyField = insertedItem.find('.row-destroy');
    const removeRow = function(event){
      event.preventDefault();
      destroyField.val('1');
      insertedItem.hide();
    };
    var removeButton = insertedItem.find('.row-remove');
    removeButton.on('click', removeRow);
  }

  const setupSubjectGenericAddressForm = function(){
    $(document).on('cocoon:after-insert', function(e, insertedItem, originalEvent) {
      if ($(insertedItem).hasClass('subject-generic-address-element')) {
        setupSubjectGenericAddressElement(insertedItem);
      }
    });
    _.each($('.subject-generic-address-element'), function(el){
      setupSubjectGenericAddressElement($(el));
    });
  }

  const setupSubjectBankAccountElement = function(insertedItem){
    var destroyField = insertedItem.find('.row-destroy');
    const removeRow = function(event){
      event.preventDefault();
      destroyField.val('1');
      insertedItem.hide();
    };
    var removeButton = insertedItem.find('.row-remove');
    removeButton.on('click', removeRow);
  }

  const setupSubjectBankAccountForm = function(){
    $(document).on('cocoon:after-insert', function(e, insertedItem, originalEvent) {
      if ($(insertedItem).hasClass('subject-bank-account-element')) {
        setupSubjectBankAccountElement(insertedItem);
      }
    });
    _.each($('.subject-bank-account-element'), function(el){
      setupSubjectBankAccountElement($(el));
    });
  }


  const setupSubjectUploadElement = function(insertedItem){
    var destroyField = insertedItem.find('.row-destroy');
    const removeRow = function(event){
      event.preventDefault();
      destroyField.val('1');
      insertedItem.hide();
    };
    var removeButton = insertedItem.find('.row-remove');
    removeButton.on('click', removeRow);
  }

  const setupSubjectUploadForm = function(){
    $(document).on('cocoon:after-insert', function(e, insertedItem, originalEvent) {
      if ($(insertedItem).hasClass('subject-upload-element')) {
        setupSubjectUploadElement(insertedItem);
      }
    });
    _.each($('.subject-upload-element'), function(el){
      setupSubjectUploadElement($(el));
    });
  }

  const setupSubjectConnectionElement = function(insertedItem){
    var connectedSubjectNameField = insertedItem.find('.connected-subject-name');
    var connectedIdField = insertedItem.find('.connected-id');
    var connectedFiscalid = insertedItem.find('.connected-fiscalid');
    var connectedAddress = insertedItem.find('.connected-address');
    var originId = insertedItem.find('.origin-id').val();

    const subjectChosen = function(){
      var chosen = connectedSubjectNameField.getSelectedItemData();
      connectedIdField.val(chosen.id);
      connectedFiscalid.html(chosen.fiscalid);
      connectedAddress.html(chosen.address_sentence);
    }

    var options = {
      url: function(phrase) {
        return "/subjects.json?q[id_not_eq]="+originId+"&q[first_name_or_last_name_or_business_name_cont]=" + phrase;
      },
      getValue: "name",
    	template: {
    		type: "custom",
    		method: function(value, item) {
    			return "<span>" + item.name + "</span></br><small class=\"text-muted\">" + item.fiscalid + "</small>";
    		}
    	},
      list: {
        match: {
          enabled: true
        },
        onChooseEvent: subjectChosen
      },
      theme: "square",
    };

    connectedSubjectNameField.easyAutocomplete(options);

    var destroyField = insertedItem.find('.row-destroy');
    const removeRow = function(event){
      event.preventDefault();
      destroyField.val('1');
      insertedItem.hide();
    };
    var removeButton = insertedItem.find('.row-remove');
    removeButton.on('click', removeRow);

  }

  const setupSubjectConnectionForm = function(){
    $(document).on('cocoon:after-insert', function(e, insertedItem, originalEvent) {
      if ($(insertedItem).hasClass('subject-connection-element')) {
        setupSubjectConnectionElement(insertedItem);
      }
    });
    _.each($('.subject-connection-element'), function(el){
      setupSubjectConnectionElement($(el));
    });
  }

  OnloadHandler(function(){
    setupSubject();
    setupSubjectConnectionForm();
    setupSubjectUploadForm();
    setupSubjectBankAccountForm();
    setupSubjectGenericAddressForm();
    setupSubjectWarehouseForm();

    toggleSubjectDomicile();
    togglePersonBusiness();
  })


})()